import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { intl } from 'lang/intl'

import { TtIcon as Icon } from '@23/ui-react'

import Avatar from '../AvatarComponent/AvatarComponent'

import './SpeakerRowComponent.scss'

const SpeakerRowComponent = ({
  name,
  title,
  link,
  linkedin,
  facebook,
  twitter,
  company,
  avatarUrl,
  isHost = false,
  disabled = false,
}) => (
  <div
    className={['speaker-row', disabled ? 'speaker-row-disabled' : '']
      .filter(Boolean)
      .join(' ')}
  >
    <Avatar imageSrc={avatarUrl} name={name} size={35} shape="square" />
    <div className="speaker-row-nameplates">
      <div className="speaker-row-name-container">
        <p className="speaker-row-name">{name}</p>
        {isHost && (
          <div className="speaker-row-role">
            <FormattedMessage defaultMessage="Host" />
          </div>
        )}
      </div>
      {title && (
        <p className="speaker-row-title">
          {title}
          {company && (
            <FormattedMessage
              // eslint-disable-next-line formatjs/prefer-full-sentence
              defaultMessage=" • {company}"
              values={{ company }}
            />
          )}
          <span className="speaker-row-social-icons">
            {link && (
              <a href={link} target="_new" rel="noreferrer">
                <Icon
                  name="globe"
                  library="one"
                  className="icon"
                  aria-label={intl.formatMessage({
                    defaultMessage: 'website link',
                  })}
                />
              </a>
            )}
            {linkedin && (
              <a href={linkedin} target="_new" rel="noreferrer">
                <Icon
                  name="linkedin"
                  library="one/logos"
                  className="icon"
                  aria-label={intl.formatMessage({
                    defaultMessage: 'linkedin link',
                  })}
                />
              </a>
            )}
            {facebook && (
              <a href={facebook} target="_new" rel="noreferrer">
                <Icon
                  name="facebook"
                  library="one/logos"
                  className="icon"
                  aria-label={intl.formatMessage({
                    defaultMessage: 'facebook link',
                  })}
                />
              </a>
            )}
            {twitter && (
              <a href={twitter} target="_new" rel="noreferrer">
                <Icon
                  name="twitter"
                  library="one/logos"
                  className="icon"
                  aria-label={intl.formatMessage({
                    defaultMessage: 'twitter link',
                  })}
                />
              </a>
            )}
          </span>
        </p>
      )}
    </div>
  </div>
)

SpeakerRowComponent.propTypes = {
  name: PropTypes.string.isRequired,
  title: PropTypes.string,
  company: PropTypes.string,
  avatarUrl: PropTypes.string,
  facebook: PropTypes.string,
  twitter: PropTypes.string,
  linkedin: PropTypes.string,
  link: PropTypes.string,
  isHost: PropTypes.bool,
  disabled: PropTypes.bool,
}

// oxlint-disable-next-line import/no-default-export
export default SpeakerRowComponent
